import { Decimal } from 'decimal.js';
/**
 * The package's own decimal configuration (§4.4): 28 significant digits, ties to even unless `round()` names
 * `halfUp`. A clone, so nothing else that happens to use decimal.js can change the language's arithmetic.
 * Precision is significant digits, not decimal places; a currency's decimals are `round()` against
 * `Currency.decimalPlaces`.
 */
export const FormulaDecimal = Decimal.clone({ precision: 28, rounding: Decimal.ROUND_HALF_EVEN });
